import { gql } from "@apollo/client";

export const GET_USER_WALLET_BY_EMAIL = gql`
  query GetUserWalletByEmail($email: String!) {
    userWallet(email: $email) {
      didSucceed
      errorCode
      value {
        id
        currency
        paymentProfileId
        expirationDate
        cardType
        binNumber
      }
    }
  }
`;

export const GET_USER_WALLET_BY_USER_ID = gql`
  query GetUserWalletByUserId($userId: Int!) {
    userWallet(userId: $userId) {
      didSucceed
      errorCode
      value {
        id
        currency
        paymentProfileId
        expirationDate
        cardType
        binNumber
      }
    }
  }
`;
